module.exports = __webpack_public_path__ + "img/2-eight.31f1d178.png";